module.exports = __webpack_public_path__ + "static/media/licenta19.93e184cc.png";